// App Badge Service
// Sets the PWA app icon badge to show the number of open work orders.
// Uses the Badging API (supported on Android Chrome, iOS Safari 16.4+, desktop Chrome/Edge).

import api from '../api';

/**
 * Check if the Badging API is supported
 */
export function isBadgeSupported() {
  return 'setAppBadge' in navigator;
}

/**
 * Fetch open work order count from the server and update the app badge.
 * Silently fails if the Badging API is not supported or the request fails.
 */
export async function updateAppBadge() {
  if (!isBadgeSupported()) return;

  try {
    const response = await api.get('/work-orders/stats/dashboard');
    const count = response.data.total || 0;

    if (count > 0) {
      await navigator.setAppBadge(count);
    } else {
      await navigator.clearAppBadge();
    }
  } catch (e) {
    // Silently fail - badge is non-critical
  }
}

/**
 * Clear the app badge (call on logout)
 */
export async function clearAppBadge() {
  if (!isBadgeSupported()) return;

  try {
    await navigator.clearAppBadge();
  } catch (e) {
    // Silently fail
  }
}
